import Api from "~/core/helper/apiHelper";

export function getLectureByIdAsync({ lectureId }) {  
  return Api.asyncGet(`content/lecture/${lectureId}`);
}
